import MobilePrefixSelectField from './mobile-prefix-select-field.vue';

export default MobilePrefixSelectField;
